<template>
    <transition name="modal-fade">
        <div class="modal-backdrop" v-bind:class="className">
            <div class="modal-overlay" @click="back()"></div>
            <div class="modal">
                <article v-if="resource">

                    <header>
                        <figure><i class="icon icon-icon_calendar"></i></figure>
                        <div>
                            <span class="breadcrumb">
                                Branch <i class="icon icon-icon_arrow-right"></i> Edit
                            </span>
                            <h1>{{ resource.name ? resource.name : 'Nouveau' }}</h1>
                        </div>
                        <div class="spacer"></div>
                        <div class="buttons">
                            <button @click="back()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
                            <button @click="submit()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
                        </div>
                    </header>

                    <main>

                         <languages :translations="resource.translations" :localesLoaded="localesLoaded" :locales="locales" v-model="locale"></languages>

                        <tabs :options="{ useUrlFragment: false }">
                            <tab name="Information">

                              <fieldset>
                                <h3>Détail</h3>
                                <p class="headline"></p>

                                <form-toggle label="Retrait possible" v-model="resource.has_pickup"></form-toggle>

                                <div class="form-multilang" v-if="localesLoaded" :class="locale">
                                  <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                                      <form-text :translate-key="'name'" :translations="resource.translations" :lang="client.id" :label="'Nom'" v-model="resource.translations[client.id].name" required="true"></form-text>
                                  </div>
                                </div>

                                <div class="form-multilang" v-if="localesLoaded" :class="locale">
                                  <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                                      <form-textarea :translate-key="'description'" :translations="resource.translations" :lang="client.id" :label="'Description'" v-model="resource.translations[client.id].description"></form-textarea>
                                  </div>
                                </div>

                                <form-text label="Email" v-model="resource.email" name="email"></form-text>
                                <form-phone label="Numéro téléphone" v-model="resource.phone"></form-phone>
                                <form-phone label="Numéro Fax" v-model="resource.fax"></form-phone>

                                <form-select-new label="Template facture"
                                                 multiple="false"
                                                 v-model="resource.invoice_template"
                                                 :default="invoice_template_id"
                                                 :options="templates"></form-select-new>

                              </fieldset>

                              <fieldset>
                                <h3>Adresse</h3>
                                <p class="headline"></p>

                                <form-toggle label="Siège central" v-model="resource.is_headquarter"></form-toggle>
                                <form-toggle label="Entrepôt" v-model="resource.is_storage"></form-toggle>
                                <form-toggle label="Boutique" v-model="resource.is_store"></form-toggle>

                                <hr>

                                <form-text label="Adresse" v-model="resource.street" name="street"></form-text>
                                <form-text label="Adresse numéro" v-model="resource.street_number" name="street_number"></form-text>
                                <form-text label="Complément d'adresse" v-model="resource.street_complement" name="street_complement"></form-text>

                                <group-line-2>
                                  <form-text label="Code postal" v-model="resource.postal_code" name="postal_code"></form-text>
                                  <form-text label="Ville" v-model="resource.locality" name="locality"></form-text>
                                </group-line-2>

                                <form-select label="Pays" multiple="false" v-model="resource.country" :default="resource.country_id" :options="$store.state.countries"></form-select>

                              </fieldset>

                            </tab>
                        </tabs>

                    </main>
                </article>
            </div>
        </div>
    </transition>
</template>
<script>
    import BranchService from './BranchService.js';
    import Edit from '../../../layouts/Edit.vue';
    import InvoiceTemplateService from '../invoice-template/InvoiceTemplateService.js';

    export default {
        extends: Edit,
        data () {
            return {
                BranchService: null,
                templates: null,
                invoice_template_id: null,
                resource: {}
            }
        },
        mounted: function(){
            /*
            BranchService.getPolicyMethod('entity').then(response => {
                self.policyMethods = response.data;
            });
            */
          InvoiceTemplateService.all().then(response => {
            this.templates = response.data
            this.isLoading = false
          });

        },
        methods: {
            resourceLoaded: function(){
                this.localesLoaded = true;
                this.setTranslations(['name','description']);
                this.invoice_template_id = this.resource.invoice_template_id || null;
            },
            getResource: function(){
                return BranchService
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/config/branch/Edit.vue